import Content from './content';
import Button from '@CS/components/Button';
import { useTranslation } from '@CS/hooks';
import CSS from './Confirmation.module.css';
import { Popup } from '@CS/components/Popups';
import type { PopupProps } from '@CS/components/Popups';
import { type CSSProperties, useState, useRef } from 'react';

type ConfirmationProps = PopupProps & {
  onSubmit: () => void;
  onCancel: () => void;
};

export const Confirmation = ({
  onSubmit,
  onCancel,
  children,
  ...props
}: ConfirmationProps) => {
  const confirmed = useRef(false);
  const [visible, setVisible] = useState(true);
  const { title, confirm, back } = useTranslation(Content);
  const onClose = () => (confirmed.current ? onSubmit() : onCancel());

  const onClick = (confirm: boolean) => {
    confirmed.current = confirm;
    setVisible(false);
  };

  const dialogStyle = {
    flexDirection: 'column',
    display: 'flex'
  } as CSSProperties;

  return (
    <Popup
      customStyle={dialogStyle}
      onClose={onClose}
      close={!visible}
      {...props}
    >
      <h3 className={CSS.confirmTitle}>{title}</h3>
      <div className={CSS.contentContainer}>{children}</div>

      <div className={CSS.buttonsContainer}>
        <Button onClick={() => onClick(true)} text={confirm} width="100%" />
        <Button onClick={() => onClick(false)} text={back} width="100%" />
      </div>
    </Popup>
  );
};
